import React, { useMemo } from 'react';

import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block, OneColumn } from 'components/page';
import { useListagemContext } from 'context/ListagemContext';
import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { TradeTagListFilter } from 'pages/marketing-trade/trade/tag/components';
import { RequestTradeTag, TradeTag } from 'pages/marketing-trade/trade/tag/types';

const generateTagList = (data: TradeTag[] | undefined): GridRowsProp => {
    if (Array.isArray(data) && data.length) {
        return data.map((item, index) => ({
            id: index + 1,
            idTagPecaTrade: item.idTagPecaTrade,
            dsTagPecaTrade: item.dsTagPecaTrade,
        }));
    }

    return [];
};

export function TradeTagListComp() {
    const { filter, page, limit, sort } = useListagemContext();
    const RequestListagem = useRequestListagem();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/tagpecatrade',
        filter,
        sort: sort && sort.length > 0 ? sort : [{ property: 'idTagPecaTrade', direction: 'DESC' }],
        columns: 'idTagPecaTrade,dsTagPecaTrade',
        page,
        limit,
    };

    const { isFetching, data, refetch } = useQuery(
        [requestOptions],
        (): Promise<RequestTradeTag> => RequestListagem(requestOptions).then((res: any) => res.data),
    );

    const columns: GridColDef[] = useMemo(
        () => [
            { field: 'idTagPecaTrade', headerName: 'Código', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'dsTagPecaTrade', headerName: 'Descrição', alignItems: 'center', flex: 4, type: 'string' },
            {
                field: 'acoes',
                align: 'center',
                headerAlign: 'center',
                headerName: 'Ações',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                width: 110,
                renderCell: ({ row }) => (
                    <EditRemoveBtn
                        id={row.idTagPecaTrade}
                        showEditBtn={true}
                        showRemoveBtn={true}
                        editUrl="form/"
                        removeUrl={`gestao/tagpecatrade/${row.idTagPecaTrade}`}
                        sx={{ ml: 'auto', p: 1.5 }}
                    />
                ),
            },
        ],
        [refetch],
    );

    return (
        <OneColumn title="Tags Trade" goBackButton createButton>
            <TradeTagListFilter />

            <Block>
                <PanelGrid rows={generateTagList(data?.data)} reload={refetch} loading={isFetching} columns={columns} remote={false} />
            </Block>
        </OneColumn>
    );
}
